export default {
  translation: {
    common: {
      emailOrUsername: 'Correo o nombre de usuario',
      invalidEmailOrUsername: 'Correo o nombre de usuario incorrecto',
      invalidPassword: 'Contraseña incorrecta',
      logInToPlanka: 'Iniciar sesión en Planka',
      noInternetConnection: 'Sin conexión a internet',
      pageNotFound_title: 'Página no encontrada',
      password: 'Contraseña',
      projectManagement: 'Gestión de Proyectos',
      serverConnectionFailed: 'Conexión con el servidor fallida',
      unknownError: 'Error desconocido, intenta más tarde',
    },

    action: {
      logIn: 'Iniciar sesión',
    },
  },
};
